import type { IApiGetCategoryListItemResponseBody } from '~/lib/api/modules/Categories';

export type ICategoryFilterType = 'category' | 'link';

export type ICategoryFilter = {
  includeIds?: Array<string>;
  excludeIds?: Array<string>;
  includeTypes?: Array<ICategoryFilterType>;
  excludeTypes?: Array<ICategoryFilterType>;
};

export const categoryFilterPredicate = (
  category: IApiGetCategoryListItemResponseBody,
  filter: ICategoryFilter,
): boolean => {
  const isIdIncluded = filter.includeIds?.includes(category._id) ?? true;
  const isIdExcluded = filter.excludeIds?.includes(category._id) ?? false;

  const isLink = !!category.action;
  const isTypeIncluded = filter.includeTypes
    ? filter.includeTypes.includes(isLink ? 'link' : 'category')
    : true;
  const isTypeExcluded = filter.excludeTypes
    ? filter.excludeTypes.includes(isLink ? 'link' : 'category')
    : false;

  return isIdIncluded && !isIdExcluded && isTypeIncluded && !isTypeExcluded;
};
